import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import Form from "components/features/MyPlans/Create/Form";
import { useEffect, useRef } from "react";
import { formTypes } from "utils/Types";
import { clearMyPlanDetails } from "../MyPlanDetails/MyPlanDetails.slice";
import { useAppDispatch } from "redux/hooks";
import { useLocation } from "react-router-dom";

interface Props {
  openEditPlan: boolean;
  setOpenEditPlan: any;
}

function Edit(props: Props) {
  const formRef = useRef<any>(null);
  const { openEditPlan, setOpenEditPlan } = props;

  const formSubmit = () => {
    formRef?.current?.submitEditForm();
  };

  const handleCloseEditDialog = () => {
    setOpenEditPlan(false);
  };

  return (
    <DialogFormation
      title="Edit plan"
      openDialog={openEditPlan}
      handleClose={handleCloseEditDialog}
      actionConfig={
        <div className="modal-config-wrapper">
          <Button variant="secondary" label="Cancel" onClick={handleCloseEditDialog} />
          <Button variant="primary" label="Save" onClick={formSubmit} />
        </div>
      }
    >
      <Form
        ref={formRef}
        handleCloseDialog={handleCloseEditDialog}
        isEdit
      />
    </DialogFormation>
  );
}

export default Edit;
